import { REVIEW_TYPES } from "../../../../consts";
import { axiosRequest } from "../../../../service";
import { REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT, REACT_APP_HEALTH_REQUEST_INVESTIGATION, REACT_APP_HEALTH_MEDICAL_REQUEST_INVESTIGATIONS, REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_ENDPOINT } from "../../../../urls";
import { formatDocumentDetails } from "../../../../utilFunctions";

export const requestInvestigation = async (claimId, payload) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_HEALTH_REQUEST_INVESTIGATION}?claimId=${claimId}`,
      payload
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getInvestigationTable = async (claimId, investigationType) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_HEALTH_MEDICAL_REQUEST_INVESTIGATIONS}?claimId=${claimId}&investigationType=${investigationType}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getMedicalRemarks = async (mrId) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/medical-reviews/${mrId}/remarks`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching remarks:", error);
    return null;
  }
};

export const addInvestigationRemarks = async (investigationId) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/investigation/${investigationId}/remarks`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching remarks:", error);
    return null;
  }
};

export const addAndClosingRemarks = async (
  id,
  claimId,
  status,
  remarks,
  reviewType,
  claimHandler,
  files,
  // actionType
) => {
  try {
    const formData = new FormData();    
    
    // Append files
    files?.forEach(file => {
      formData.append('files', file?.file);
    });

    let request = {
      medicalReviewId: id,
      claimId: claimId,
      status: status,
      remarks: remarks,
      reviewType: reviewType,
      claimHandler: claimHandler,
      // actionType: actionType
    }

    if(reviewType === REVIEW_TYPES.INVESTIGATION) {
      delete request.medicalReviewId;
      request = {...request, investigationId: id}
    }
    

    // Construct query parameters
    const queryParams = new URLSearchParams(request).toString();

    const response = await axiosRequest().put(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claims/review?${queryParams}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response?.data;
  } catch (error) {
    console.error("Error updating remarks:", error);
    return null;
  }
};

export const fetchRemarksAndDocuments = async (medicalReview) => {
  try {
    const remarksData = await getMedicalRemarks(medicalReview.investigationId);
    const formattedDocs = formatDocumentDetails(remarksData.documentDetails);

    return {
      remarks: remarksData?.remarks || [],
      documents: formattedDocs,
    };
  } catch (error) {
    console.error("Failed to fetch remarks:", error);
    throw error;
  }
};

export const fetchReportDocuments = async (medicalReview) => {
  try {
    const remarksData = await getMedicalRemarks(medicalReview.investigationId);

    if (remarksData?.documentDetails?.length > 0) {
      const formattedDocs = formatDocumentDetails(remarksData.documentDetails);
      return formattedDocs;
    } else {
      console.warn("No documents found in remarksData.");
      return [];
    }
  } catch (error) {
    console.error("Failed to fetch remarks:", error);
    throw error;
  }
};

export const fetchInvestigationOptions = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claims/trigger-reasons`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching remarks:", error);
    return null;
  }
};

export const triggerStatus = async ({
  investigationId,
  investigationInitiatedBy,
  investigationType,
  claimId
}) => {
  try {
    const requestBody = {
      investigationId,
      investigationInitiatedBy,
      investigationType,
      claimId
    };

    const response = await axiosRequest().put(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claims/investigation`,
      requestBody
    );

    return response?.data;
  } catch (error) {
    console.error("Error triggering investigation status:", error);
    return null;
  }
};